import { Injectable } from '@angular/core';
import { DocumentModel } from 'src/models/models';
import * as firebase from 'firebase/app';
import 'firebase/firestore';

@Injectable({
	providedIn: 'root',
})
export class DatabaseService {

	public add(document: DocumentModel) {
		const dbRef: any = firebase.app().firestore().collection(document.collection);
		return dbRef.add(Object.assign({}, document.data)).then((response) => {
			document.id = response.id;
			return document;
		});
	}

	public get(document: DocumentModel) {
		const docRef: any = firebase.app().firestore().collection(document.collection).doc(document.id);
		return docRef.get().then( (document) => {
			return document;
		})
	}

	public getAll(collectionId: string){
		const collRef: any = firebase.app().firestore().collection(collectionId);
		return collRef.get().then ((collection) => {
			return collection
		});
	}
}
